import * as React from 'react';
import { inject, observer } from 'mobx-react';
import { MdField as MaterialField } from '@bytebrand/fe-ui-core-autobahn/compat';
import { Button } from '@bytebrand/fe-ui-core-autobahn/ui';
import form from './formConfigs/PasswordResetFormConfig';
import styles from './modals.styl';
const PasswordResetModal = inject('authStore')(observer(({ t, onSuccess, authStore: { errors } }) => {
    const onSubmit = () => {
        form.submit().then((form) => {
            if (!form.hasError) {
                onSuccess();
            }
        });
    };
    const onBlur = (e, field) => {
        e.preventDefault();
        field.validate().then((subField) => {
            if (!field.isValid) {
                subField.showErrors(true);
            }
        });
    };
    const onFocus = (e, field) => {
        e.preventDefault();
        field.validate();
    };
    return (React.createElement(React.Fragment, null,
        React.createElement("span", { className: styles.desc }, t('offerRequest.passwordResetMessage')),
        React.createElement("div", { className: styles.recoveryWrapper },
            React.createElement(MaterialField, { onChange: value => form.$('email').onChange(value, form.$('email').name), label: t(`CheckoutPage:contactInformation:fieldLabels.email`), value: form.$('email').value, ...{
                    onBlur: (e) => onBlur(e, form.$('email')),
                    onFocus: (e) => onFocus(e, form.$('email'))
                }, type: form.$('email').type, error: form.$('email').hasError && form.$('email').error, helperText: form.$('email').showError ? form.$('email').error : '', classNameInput: styles.fieldInput })),
        React.createElement(Button, { className: styles.resetBtn, variant: 'filled', onClick: onSubmit }, t('offerRequest.resetPasswordModal'))));
}));
export default PasswordResetModal;
